export default () => {
    const productDetail = document.querySelector(".in-e-shop.type-detail");
    const isEN = shoptet.cookie.get("language") === "en";

    if (productDetail) {
        $(".p-info-wrapper").prepend($(".p-short-description"));
        $(".p-info-wrapper").prepend($(".p-detail-inner-header"));
        $(".add-to-cart").prepend($(".p-final-price-wrapper"));
        $(".availability-value").insertBefore($(".add-to-cart"));

        $("#productsAlternative").removeClass("tab-pane").removeClass("fade");
        $("#productsAlternative").removeAttr("tabpanel");

        const productsDetail = document.querySelectorAll(".p-info-wrapper");
        if (productsDetail) {
            const merchFlag = document.querySelector(".flag.flag-merch");
            if (merchFlag) {
                const property = document.querySelectorAll(".property")

                if (property) {
                    property.forEach((property) => {
                        property.classList.add("hide-before")
                    })
                }
            }

        }

        const pPrices = document.querySelectorAll(".product .prices .price-additional");
        if (pPrices) {
            pPrices.forEach((price => {
                price.innerText = `${isEN ? "VAT included" : "Včetně DPH"}`
            }));
        }

        const detailPrices = document.querySelector(".p-final-price-wrapper .price-additional");
        if (detailPrices) {
            detailPrices.innerText = `${isEN ? "VAT included" : "Včetně DPH"}`
        }
    }
};